const TITLESIZE = 20;
const TITLEBOTTOMMARGIN = [0, 0, 0, 10];
const SUBTITLESIZE = 17;
const SUBSUBTITLESIZE = 14;
const TEXTSIZE = 10;
const DESCCOLOR = 'grey';
const INDENT = [10, 0, 0, 10];

function filter(a) {
  if(Array.isArray(a)) {
    a.forEach(e => {
      if(Array.isArray(e))
        return filter(e)
      else {
        a = a.filter(e => e != 'undefined');
        a = a.filter(e => e != undefined);
        a = a.filter(e => e != null);
        if(!!a.length) {
          return a;
        }
      }
    })
  }
  return a
}

export function generatePDF(isld) {

  function updateStructure () {
    /**
     * Test if island contains info relative to blocks. If not, block doesn't display.
     * The fields key can be omitted if the table is present in only one block
     */
    let structure = {
      main: structureChecker([{table: 'NOM_ILOTS'}, {table: 'DESCRIPTION_GEO'}, {table: 'PERTURBATION_ANTHROPIQUE', fields: ['CAPACITES_D_ACCES']}, {table: 'STATUS_FONCIER', fields: ['COMMUNES']}]),
      pmf: structureChecker([{table: 'STATUS_FONCIER', fields: ['DOMAINE', 'PROPRIETAIRES', 'GESTIONNAIRE']}]),
      protect: structureChecker([{table: 'RNN'}, {table: 'RNR'}, {table: 'RNCFS'}, {table: 'N_2000'}, {table: 'PNR'}, {table: 'PNM'}, {table: 'APB'}, {table: 'SITE_CLASSE_INSCRIT'}, {table: 'GRAND_SITE'}]),
      gestion: structureChecker([{table: 'GESTION'}]),
      geomorph: structureChecker([{table: 'GEOMORPHOLOGIE_GEOLOGIE'}]),
      occupHisto: structureChecker([{table: 'ARCHEO_HISTORIQUE', fields: ['DESCRIPTION']}]),
      periodModern: structureChecker([{table: 'PERTURBATION_ANTHROPIQUE', fields: ['DESCRIPTION']}]),
      occupHistoSide: structureChecker([{table: 'ARCHEO_HISTORIQUE', fields: ['DESCRIPTION']}]),
      periodModernSide: structureChecker([{table: 'PERTURBATION_ANTHROPIQUE', fields: ['DESCRIPTION']}]),
      habitat: structureChecker([{table: 'HABITAT'}]),
      flore: structureChecker([{table: 'FLORE'}, {table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FLORE', 'NOM_SCI_FLORE', 'DATE_OBS_FLORE']}]),
      floreInva: structureChecker([{table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FLORE', 'NOM_SCI_FLORE', 'DATE_OBS_FLORE']}]),
      faune: structureChecker([{table: 'INVERTEBRE'}, {table: 'REPTILE'}, {table: 'MAMMIFERE'}, {table: 'FAUNE'}]),
      faunePatri: structureChecker([{table: 'FAUNE'}]),
      fauneInva: structureChecker([{table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FAUNE', 'NOM_SCI_FAUNE', 'DATE_OBS_FAUNE']}]),
      recensDec: censusChecker({table: 'OISEAUX_MARINS_NICHEURS', lookFor: ['R_D_MOY', 'RESULT_SUIVIS']}),
      autresSp: censusChecker({table: 'AUTRES_SP_AVIF', lookFor: ['RESULT']}),
      wetland: censusChecker({table: 'WETLAND', lookFor: ['EFF_WETLAND_MIN', "EFF_WETLAND_MAX"]}),
    }

    structure = { ...structure, occupHum: structureContainerChecker([structure.occupHisto, structure.periodModern, structure.occupHistoSide, structure.periodModernSide])}
    structure = { ...structure, occupSide: structureContainerChecker([structure.occupHistoSide, structure.periodModernSide])}
    structure = { ...structure, patri: structureContainerChecker([structure.habitat, structure.flore, structure.floreInva, structure.faune, structure.faunePatri, structure.fauneInva, structure.recensDec, structure.autresSp, structure.wetland])}
    structure = { ...structure, census: structureContainerChecker([structure.recensDec, structure.autresSp, structure.wetland])}
    
    return structure
  }

  function structureContainerChecker (array) {
    return array.some(e => !!e)
  }

  function structureChecker (array) {
    let keys = Object.keys(isld);
    let informationIsPresent = false
    
    for(let i = 0; i < array.length; i++) {
      if(keys.includes(array[i].table)){
        if(!!array[i].fields) {
          if(!!isld[array[i].table]) {
            for(let ii = 0; ii < array[i].fields.length; ii++) {
              if(!!isld[array[i].table][array[i].fields[ii]]) {
                informationIsPresent = true;
                break;
              }
            }
          }
        }
        else {
          informationIsPresent = true;
          break;
        }
      }
    }

    return informationIsPresent;
  }

  function censusChecker ({table, lookFor} = obj) {
    let informationIsPresent = false;
    if(!!isld[table]){
      let keys = Object.keys(isld[table]);
      console.log({keys})
      for(let i = 0; i < keys.length; i++) {

        let innerKeys = Object.keys(isld[table][keys[i]]);

        for(let ii = 0; ii < innerKeys.length; ii++) {
          for(let iii = 0; iii < lookFor.length; iii++) {
            if(Object.keys(isld[table][i]).includes(lookFor[iii])) {
              informationIsPresent = true;
              break;
            }
          }
        }
      }
    }
    console.log(table, {informationIsPresent})
    return informationIsPresent;
  }

  let pdfStructure = updateStructure()

  console.log('Structure', pdfStructure)

  // init
  //let isld = { img: { }, ID: { HISTOLITT_V2: 'HISTOLITT_V2'}, NOM_ILOTS: { NOM_SHOM: 'NOM_SHOM' } };
  isld.img = {}
  
  /*let wpcText = document.getElementsByClassName('wpc-text');
  for(let i = 0; i < wpcText.length; i++) {
    if(!!wpcText[i].lastChild.value) {
      let [table, field] = wpcText[i].id.split(':::');
      if(!isld[table])
        isld[table] = {};
      isld[table][field] = wpcText[i].lastChild.value;
    }
  }*/

  console.log('ISLD:', isld);
  let wpcImg = document.getElementsByClassName('wpc-img');
  for(let i = 0; i < wpcImg.length; i++) {
    if(!!wpcImg[i].src) {
      isld.img[wpcImg[i].id] = wpcImg[i].src
    }
  }

  // String
  function s(desc, table, field, margin = [0, 0, 0, 0]) {
    if(!!isld[table] && !!isld[table][field]) {
      return {
        text: 
          [
            !!desc.length ? {text: `${desc} :  `, color: DESCCOLOR} : null,
            {text: `${isld[table][field]}`, margin: [ 10, 0, 0, 0 ]},
          ], margin: margin, alignment: 'justify'
        }
      }
    return null;
  }

  // Image
  function i(src) {
    if(src != null)
    return({
      image: src,
      width: 210
    })
  }

  // Table
  function t(...args) {
    let title = args[0].text != '' ? { ...args[0], margin: TITLEBOTTOMMARGIN} : '';
    let data = args[args.length - 1];

    let overTitle = {};
    let header = [];
    let content = [];
    data.forEach((d, i) => {
      if(Array.isArray(d[1])) {
        overTitle[i] = [d[0], d[1].length] // [name, colSpan]
        
        d[1].forEach(l => {
          header.push(l[0])
          let columnFields = []
          l[1].fields.forEach(field => {
            if(isld[l[1].table])
              columnFields.push(isld[l[1].table][field]);
          })
          content.push(columnFields)
        });
      } else {
        header.push(d[0]);
        let columnFields = [];
        d[1].fields.forEach(field => {
          if(isld[d[1].table])
            columnFields.push(isld[d[1].table][field]);
        })
        content.push(columnFields);
      }
      
    });

    let _overTitle = [];
    let _widths = [];
    let _header = header.map((h, i) => {
      _widths.push('auto');
      if(!!overTitle[i])
        _overTitle.push({text: overTitle[i][0], colSpan: overTitle[i][1], noWrap: true, border: [false, false, false, true], alignment: 'center', color: DESCCOLOR});
      else
        _overTitle.push({ text: '', border: [false, false, false, false]})
      return { text: h, border: [false, false, false, true], color: DESCCOLOR};
    });
    let _content = content.map(c => {
        return {text: c, fontSize: TEXTSIZE, alignment: 'center', border: [false, false, false, false]}
    });
    content = content.filter(e => e.length > 0);
    content = filter(content)
    let hasContent = false
    content.forEach(entry => {
      if(entry[0] != undefined) {
        hasContent = true
      }
        
    });
    console.log('has content', hasContent, title, _content)
    if(hasContent)
      return([
        title,
        {
          stack: [
            {
              table: {
                headerRows: !!_overTitle.length ? 2 : 1,
                dontBreakRows: true,
                widths: _widths,
                margin: [ 10, 10, 0, 10],
                body: [
                  _overTitle,
                  _header,
                  _content
                ]
              },
              layout: {
                hLineWidth: function (i, node) {
                  return  1;
                },
                vLineWidth: function (i, node) {
                  return 1;
                },
                hLineColor: function (i, node) {
                  return 'gray';
                },
                vLineColor: function (i, node) {
                  return 'gray';
                }
              }
            }
          ], margin: INDENT
        }
      ])
    return null
  }

  // Census table
  function census(title, options, table) {
    console.log('Options', table, options.decennal, options.listeRouge)
    if(!isld[table])
      return null

    title = { text: title, margin: TITLEBOTTOMMARGIN, alignment: 'center'};

    let displayedYears = [];
    if(!options.decennal) {
      let year = new Date().getFullYear();
      for(let i = 0; i <= 4; i++) {
        displayedYears.push(year - 4 + i);
      }
    }
    else
      displayedYears = [ '68 - 70', '76 - 79', '87-89', '97 - 00', '09 - 12', '20-23'];

    let decennalYears = [ [1968, 1970], [1976, 1979], [1987, 1989], [1997, 2000], [2009, 2012], [2020, 2023]];

    let header = [];
    if(options.listeRouge && table != "WETLAND") {
      header.unshift({text: 'LR BZH', border: [false, false, false, true], color: DESCCOLOR});
      header.unshift({text: 'LR FR', border: [false, false, false, true], color: DESCCOLOR});
    }

    header.unshift({text: '', border: [false, false, false, true]});

    console.log(table, {header});

    let hasContent = false

    let content = [];
    let targetKey = table == 'OISEAUX_MARINS_NICHEURS'
            ? options.decennal
              ? 'R_D_MOY'
              : 'RESULT_SUIVIS'
            : table == 'AUTRES_SP_AVIF'
              ? 'RESULT'
              : table == 'WETLAND'
                ? 'EFF_WETLAND_MIN'
                : undefined

    Object.keys(isld[table]).forEach((key, i) => {
      
                /*
      content[i] = options.decennal
      ? decennalYears.map(years => {
        let yearSegmentHasValue = false;
        for(var year = years[0]; year <= years[1]; year++) {
          let value = !!isld[table][key]
                      ? !!isld[table][key].ANNEE == year
                        ? !!isld[table][key][targetKey]
                          ? isld[table][key][targetKey]
                          : undefined
                        : undefined
                      : undefined


          if(!!value) {
            yearSegmentHasValue = true;
            hasContent = true;
            return {text: isld[table][key][year].R_D_MOY, border: [ false, false, false, false], alignment: 'center'}
          }
        }
        if(!yearSegmentHasValue)
          return {text: '', border: [ false, false, false, false]}
      })
      : displayedYears.map((y, ii) => {

        if(isld[table][key].ANNEE == y)
          console.log("test year", isld[table][key]  );

        if(isld[table][key].ANNEE == y){
          hasContent = true;
          return {text: isld[table][key][targetKey], border: [ false, false, false, false], alignment: 'center'}
        }
        return {text: '', border: [ false, false, false, false]}
      });
      */

      if(options.decennal) {
        decennalYears.map(years => {
          let yearSegmentHasValue = false;
          for(var year = years[0]; year <= years[1]; year++) {
            let value = !!isld[table][key]
                        ? !!isld[table][key].ANNEE == year
                          ? !!isld[table][key][targetKey]
                            ? isld[table][key][targetKey]
                            : undefined
                          : undefined
                        : undefined

            if(!!value) {
              yearSegmentHasValue = true;
              hasContent = true;
              content[i] = {text: isld[table][key][year].R_D_MOY, border: [ false, false, false, false], alignment: 'center'}
            }
          }
          if(!yearSegmentHasValue)
            content[i] = {text: '', border: [ false, false, false, false]}
        })
      }
      else {
        let segmentHasContent = false;
        let arrTmp = [];

        displayedYears.map((y, ii) => {
          if(isld[table][key].ANNEE == y){
            hasContent = true;
            segmentHasContent = true;
            if(table == "WETLAND")
              arrTmp.push({text: isld[table][key].EFF_WETLAND_MIN + " - " + isld[table][key].EFF_WETLAND_MAX, border: [ false, false, false, true], alignment: 'center'})
            else
              arrTmp.push({text: isld[table][key][targetKey], border: [ false, false, false, true], alignment: 'center'})
          }
          else {
            arrTmp.push({text: '', border: [ false, false, false, true]})
          }
        });
        if(segmentHasContent) {
          arrTmp.unshift({text: isld[table][i].NOM_SCI, border: [ false, false, false, true], color: DESCCOLOR})
          content.push(arrTmp);
        }
      }
    });

    header = [...header, ...displayedYears.map(y => {
      return {text: y, border: [ false, false, false, true], color: DESCCOLOR, alignment: 'center'}
    })]

    let LR = options.listeRouge
    ? ['STATUT FR', 'STATUT BZH'].map(m => {
      return {text: m, border: [ false, false, false, false], color: DESCCOLOR}
    })
    : [];

    console.log({hasContent});
    content = filter(content);
    console.log({content});

    if(hasContent){
      content.unshift(header);
      // Object.keys(isld[table])
      content.forEach((key, i) => {
        if(options.listeRouge) {
          if(table !== "WETLAND") {
            content[i].unshift({text: isld[table][key].STATUT_BZH, border: [ false, false, false, false], alignment: 'right'});
            content[i].unshift({text: isld[table][key].STATUT_FR, border: [ false, false, false, false], alignment: 'right'});
          }
        }
       // if(i > 0)
        //  content[i].unshift({text: isld[table][key].NOM_SCI, border: [ false, false, false, false], color: DESCCOLOR})
        
      });
      console.log("content", content)

      let w = content[0].map(m => 'auto');
      return(
        {
          columns: [
            { width: '*', text: '' },
            {
              width: 'auto',
              stack: [
                title,
                {
                  table: {
                    body: content,
                    widths: w
                  }
                }
              ]
            },
            { width: '*', text: '' },
          ],
          margin: TITLEBOTTOMMARGIN
        }
      )
    }
    return null
  }

  // Block
  function b(...args) {
    let title = { ...args[0], margin: TITLEBOTTOMMARGIN};;
    let test = null;
    let data = args[args.length -1];
    data.forEach(line => {
      return !!line ? test = line.text : null
    });
    if(!!test){
      return(
        {
          stack: [
            title,
            {
              stack: [
                data
              ],
              margin: INDENT
            }
          ],
          unbreakable: true
        }
      )
    }
    return null
  };

  // text line
  function tl(title, data, separator = ', ') {
    title = typeof(title) == 'string' && title.length > 0 ? { text: `${title} :  `, color: DESCCOLOR } `${title} : ` : title == '' ? '' : { text: `${title.text} :  `, color: DESCCOLOR};
    let content = data.map(textObj => !!isld[textObj.table] ? !!isld[textObj.table][textObj.field] ? textObj : null : null);
    content = content.filter(e => e != null);
    let filteredContent = content.map((textObj, i) => {
      if(!!isld[textObj.table]) {
        let _ = i == content.length - 1 ? '' : separator;
        return !! isld[textObj.table][textObj.field] ? { text: `${isld[textObj.table][textObj.field]}${_}`} : null
      }
    })

    return {
      text: [
        title,
        { text: filteredContent }
      ],
      fontSize: TEXTSIZE
    }
  }

  // Vertical List
  function vl(...args) {
    let title = { ...args[0], margin: TITLEBOTTOMMARGIN};
    let data = args[args.length - 1];
    console.log('data', data)
    let content = data.map(line => {
      let lineContent = line[1].fields.map(field => {
        if(isld[line[1].table] && isld[line[1].table][field] !== undefined)
          return `   ${isld[line[1].table][field]}`
      })
      lineContent = filter(lineContent)
      if(lineContent.some(e => e != undefined)) {
        let t = '';
        if(!!line[0].length) {
          t = `- ${line[0]} :`
        }
        return { text: [
            { text: t, color: DESCCOLOR },
            `${lineContent}`
          ], fontSize: TEXTSIZE }
      }
        
    })
    content = filter(content);
    if(!!content.length)                                    
      return (
        f(
          {key: 'floreInva'},
          title,
          content
        )
      )
  }

  // frame
  function f(...args){
    if(pdfStructure[args[0].key]){
      let content = args.map((arg, i) => {
        console.log("Arg n°", i, ": ", arg);
        if(!!arg && i > 1)
          return arg
        return null;
      });
      content = filter(content);
      if(!!content.length) {
        let items = [];
        args.forEach((arg, i) => {
           if(!!arg && i > 1)
            items.push(arg)
        })
        items.unshift(args[1]);
        return(
          {
            stack: items,
            margin: INDENT
          }
        )
      }
      return null
    }
  }

  function dig(o) {
    if(Array.isArray(o))
      return o.map(oo => {
        if(!!oo)
          return dig(oo)
      })
    if(typeof o == 'object') {
      if(!!o.stack){
        return dig(o.stack);
      }
      if(!!o.stack) {
        return o.stack[0][0].text[1].text
      }
    }
  }

  // columns
  function c(...args) {
    let a = dig(args)
    a = a.flat();
    a = a.flat();
    a = filter(a);
    console.log('c columns', a)
    if(a.length)
      return { columns: args.map(arg => {
        console.log('arg', arg);
          return arg
      }) }
    else
      return null
  };

  let docDefinition = {
    background: {
      text: 'Iles et Ilots de Bretagne  -  Bretagne Vivante',
      margin: [ 10, 10 ],
      alignment: 'right'
    },
    footer: function(currentPage, pageCount) { return(
        {
          text: currentPage.toString() + ' sur ' + pageCount,
          alignment: 'right',
          margin: [ 10, 0 ]
        }
      )
    },
    pageMargins: [ 30, 50, 30, 50 ],
    defaultStyle: {
      fontSize: 10
    },
    content: [
      {
        text : tl('', [{table: 'NOM_ILOTS', field: 'NOM_SHOM'}, {table: 'ID', field: 'HISTOLITT_V2'}], '  -  '),
        margin: [ 0, 0, 0, 30 ],
        alignment: 'center',
        fontSize: 20
      },
      {
        columns: [
          {
            stack: [
              tl({text: 'Noms'}, [{table: 'NOM_ILOTS', field: 'IGN'}, {table: 'NOM_ILOTS', field: 'NOM_2'}, {table: 'NOM_ILOTS', field: 'NOM_3'}], '; '),
              s('Archipel', 'DESCRIPTION_GEO', 'NOM_ARCHIPEL'),
              s('Commune', 'STATUS_FONCIER', 'COMMUNES'),
              tl({text: 'Coordonnées'}, [{table: 'DESCRIPTION_GEO', field: 'COORD_X'}, {table: 'DESCRIPTION_GEO', field: 'COORD_Y'}]),
              s('Type', 'DESCRIPTION_GEO', 'TYPE_ILOT'),
              {
                columns: [
                  s('Surface', 'DESCRIPTION_GEO', 'SURFACE_HISTOLITT'),
                  s('Surface d\'estran associée', 'DESCRIPTION_GEO', 'SURFACE_ESTRAN_ASSOCIEE'),
                ]
              },
              s('Altitude', 'DESCRIPTION_GEO', 'ALTITUDE_MAX_SHOM'),
              s('Distance de la côte', 'DESCRIPTION_GEO', 'DISTANCE_COTE'),
              s('Île / îlot principal', 'DESCRIPTION_GEO', 'RATTACH_ILOT_PRINCIPAL'),
              s('Orientation', 'DESCRIPTION_GEO', 'ORIENTATION'),
              s('Débarquement', 'PERTURBATION_ANTHROPIQUE', 'CAPACITES_D_ACCES'),
            ],
            unbreakable: true
          },
          i(isld.img.imgTopRight),
        ],
        margin: [0, 0, 0, 15],
        columnGap: 10
      },
      {
        columns: [
          {
            width: '*',
            text: ''
          },
          i(isld.img.imgBottomLeft),
          {
            width: '*',
            text: ''
          },
          i(isld.img.imgBottomRight),
          {
            width: '*',
            text: ''
          }
        ],
        margin: [0, 0, 0, !!isld.img.imgBottomLeft || !!isld.img.imgBottomRight ? 15 : 0], alignment: 'justify'
      },
      b(
        { text: 'Propriété / maitrise foncière', fontSize: TITLESIZE },
        [
          s('Domaine', 'STATUS_FONCIER', 'DOMAINE'),
          s('Propriétaire', 'STATUS_FONCIER', 'PROPRIETAIRES'),
          s('Maitrise foncière / usage', 'STATUS_FONCIER', 'GESTIONNAIRE'),
        ]
      ),
      vl(
        { text: 'Protection réglementaire & contractuelle / Inventaire', fontSize: TITLESIZE },
        [
          ['RNN', {table: 'RNN', fields: ['RNN', 'CODE_RNN', 'DATE', 'GESTIONNAIRE']}],
          ['RNR', {table: 'RNR', fields: ['RNR', 'CODE_RNR', 'DATE', 'GESTIONNAIRE']}],
          ['RNCFS', {table: 'RNCFS', fields: ['RNCFS', 'CODE_RNCFS', 'DATE', 'GESTIONNAIRE']}],
          ['N 2000 ZPS', {table: 'N_2000', fields: ['ZPS', 'CODE_ZPS', 'DATE_ZPS', 'OPERATEUR_ZPS']}],
          ['N 2000 ZSC', {table: 'N_2000', fields: ['ZSC', 'CODE_ZSC', 'DATE_ZSC', 'OPERATEUR_ZSC']}],
          ['PNR', {table: 'PNR', fields: ['PNR', 'CODE_PNR', 'DATE', 'OPERATEUR']}],
          ['PNM', {table: 'PNM', fields: ['PNM', 'CODE_PNM', 'DATE', 'OPERATEUR']}],
          ['APPB', {table: 'APB', fields: ['APB', 'CODE_APB', 'DATE', 'OPERATEUR']}],
          ['Site classé', {table: 'SITE_CLASSE_INSCRIT', fields: ['NOM_CLASSE', 'CODE_CLASSE']}],
          ['Site inscrit', {table: 'SITE_CLASSE_INSCRIT', fields: ['NOM_INSCRIT', 'CODE_INSCRIT']}],
          ['Grand site', {table: 'GRAND_SITE', fields: ['SITE', 'DATE', 'GESTIONNAIRE']}],
        ]
      ),
      b(
        { text: 'Gestion', fontSize: TITLESIZE },
        [
          s('Type d\'accord', 'GESTION', 'TYPE_D_ACCORD'),
          s('Surveillance et présence sur le site', 'GESTION', 'SURVEILLANCE_PRESENCE'),
          s('Plan de gestion', 'GESTION', 'PDG'),
          s('Type de gestion', 'GESTION', 'TYPE_GESTION'),
          s('Action de gestion annuelle', 'GESTION', 'ACTION_GESTION_ANNUEL'),
        ]
      ),
      b(
        { text: 'Description géomorphologique', fontSize: TITLESIZE },
        [
          s('Description', 'GEOMORPHOLOGIE_GEOLOGIE', 'DESCRIPTION'),
          s('Formation d\'intérêt', 'GEOMORPHOLOGIE_GEOLOGIE', 'FORM_INTERET'),
        ]
      ),
      f(
        {key: 'occupHum'},
        {text: 'Occupation humaine', margin: TITLEBOTTOMMARGIN, fontSize: TITLESIZE},
        c(
          [
            b(
              { text: 'Occupation historique', fontSize: SUBTITLESIZE },
              [
                s('Description', 'ARCHEO_HISTORIQUE', 'DESCRIPTION'),
              ]
            ),
            b(
              { text: '', fontSize: SUBTITLESIZE },
              [
                s('Inventaire archéologique', 'ARCHEO_HISTORIQUE', 'INVENTAIRE_ARCHEO'),
                s('Batiment historique', 'ARCHEO_HISTORIQUE', 'BATI_HISTO'),
                s('Monument historique', 'ARCHEO_HISTORIQUE', 'MONU_HISTO'),
              ]
            ),
          ]
        ),
        c(
          [
            b(
              { text: 'Période moderne', fontSize: SUBTITLESIZE },
              [
                s('Description', 'PERTURBATION_ANTHROPIQUE', 'DESCRIPTION'),
              ]
            ),
            b(
              { text: '', fontSize: SUBTITLESIZE, margin:[ 0, 40, 0, 0] },
              [
                s('Fréquentation humaine', 'PERTURBATION_ANTHROPIQUE', 'FREQ_HUMAINE'),
                s('Acteurs locaux', 'PERTURBATION_ANTHROPIQUE', 'ACTEUR_LOCAUX'),
                s('Dérangement', 'PERTURBATION_ANTHROPIQUE', 'DERANGEMENT'),
                s('Capacité d\'accueil', 'PERTURBATION_ANTHROPIQUE', 'CAPACITES_D_ACCES'),
              ]
            )
          ]
        )
      ),
      f(
        {key: 'patri', t: "lkl"},
        {text:'Patrimoine naturel et intérêt patrimonial', fontSize: TITLESIZE, margin: TITLEBOTTOMMARGIN},
        { text: 'Espèces', fontSize: SUBTITLESIZE, margin: TITLEBOTTOMMARGIN, color: DESCCOLOR },
        {
          stack: [
            f(
              {key: 'patri', t: "t"},
              { text: '', fontSize: SUBTITLESIZE, color: DESCCOLOR },
              {
                stack: [
                  f(
                    {key: 'habitat'},
                    {text: 'Habitat', fontSize: SUBTITLESIZE, margin: TITLEBOTTOMMARGIN},
                    f(
                      {key: 'habitat'},
                      {text: '', fontSize: SUBTITLESIZE, margin: TITLEBOTTOMMARGIN},
                      s('Description', 'HABITAT', 'DESCRIPTION', [0, 0, 0, 10]),
                      t(
                        { text: '' },
                        [
                          ['Habitat', {table: 'HABITAT', fields: ['NOM_HABITAT']}],
                          ['Code EUNIS', {table: 'HABITAT', fields: ['CODE_EUNIS']}],
                          ['Code EU', {table: 'HABITAT', fields: ['CODE_EU']}],
                        ]
                      )
                    )
                  ),
                  f(
                    {key: 'flore'},
                    {text: 'Flore', fontSize: SUBTITLESIZE, margin: TITLEBOTTOMMARGIN},
                    {
                      stack: [
                        {
                          stack: [
                            s('Description', 'FLORE', 'DESCRIPTION'),
                          ],
                          margin: [0, 0, 0, !!s('Description', 'FLORE', 'DESCRIPTION') ? 10 : 0]
                        },
                        t(
                          { text: 'Flore patrimoniale', fontSize: SUBSUBTITLESIZE },
                          [
                            ['Espèce', [
                              ['Nom Vern', {table: 'FLORE', fields: ['NOM_VERN']}],
                              ['Nom Sci', {table: 'FLORE', fields: ['NOM_SCI']}],
                            ]],
                            ['Protection FR', {table: 'FLORE', fields: ['PROT_NAT']}],
                            ['Dir. Hab.', {table: 'FLORE', fields: ['DIR_HAB']}],
                            ['Liste Rouge FR', {table: 'FLORE', fields: ['LR_NAT']}],
                            ['LR Massif Armoricain', {table: 'FLORE', fields: ['LR_MASSIF_ARMO']}],
                          ]
                        ),
                        vl(
                          { text: 'Flore invasive / introduite', fontSize: SUBSUBTITLESIZE},
                          [
                            ['', {table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FLORE', 'NOM_SCI_FLORE', 'DATE_OBS_FLORE']}],
                          ]
                        )
                      ]
                    }
                  ),
                  f(
                    {key: 'faune'},
                    {text: 'Faune', fontSize: SUBTITLESIZE, margin: TITLEBOTTOMMARGIN },
                    {
                      stack: [
                        {
                          stack: [
                            s('Invertébrés', 'INVERTEBRE', 'DESCRIPTION', [0, 0, 0, 10]),
                            s('Reptiles', 'REPTILE', 'DESCRIPTION', [0, 0, 0, 10]),
                            s('Mammifères', 'MAMMIFERE', 'DESCRIPTION', [0, 0, 0, 10]),
                          ],
                          margin: [0, 0, 0, 10]
                        },
                        t(
                          { text: 'Faune patrimoniale', fontSize: SUBSUBTITLESIZE },
                          [
                            ['Espèce', [
                              ['Nom Vern', {table: 'FAUNE', fields: ['NOM_VERN']}],
                              ['Nom Sci', {table: 'FAUNE', fields: ['NOM_SCI']}],
                            ]],
                            ['Protection FR', {table: 'FAUNE', fields: ['PROT_NAT']}],
                            ['Dir. Hab.', {table: 'FAUNE', fields: ['DIR_HAB']}],
                            ['Liste Rouge FR', {table: 'FAUNE', fields: ['LR_NAT']}],
                            ['LR Régionale', {table: 'FAUNE', fields: ['LR_REG']}],
                          ]
                        ),
                        vl(
                          { text: 'Faune invasive / introduite', fontSize: SUBSUBTITLESIZE },
                          [
                            ['', {table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FAUNE', 'NOM_SCI_FAUNE', 'DATE_OBS_FAUNE']}],
                          ]
                        )
                      ]
                    }
                  ),
                  f(
                    {key: 'census'},
                    {text: 'Avifaune', fontSize: SUBTITLESIZE, margin: TITLEBOTTOMMARGIN },
                    census(
                      'Recensement décennal',
                      {
                        decennal: true,
                        listeRouge: true
                      },
                      'OISEAUX_MARINS_NICHEURS'
                    ),
                    census(
                      'Autres suivis',
                      {
                        decennal: false,
                        listeRouge: false
                      },
                      'OISEAUX_MARINS_NICHEURS'
                    ),
                    census(
                      'Autres nicheurs',
                      {
                        decennal: false,
                        listeRouge: true
                      },
                      'AUTRES_SP_AVIF'
                    ),
                    census(
                      'Wetland',
                      {
                        decennal: false,
                        listeRouge: true
                      },
                      'WETLAND'
                    ),

                  )
                ]
              }
            )
          ]
        }
      ),
    ]
  };

  let fbb = {
    content: f(
      {key: 'census'},
      {text: 'Avifaune', fontSize: SUBTITLESIZE, margin: TITLEBOTTOMMARGIN },
      census(
        'Wetland',
        {
          decennal: false,
          listeRouge: true
        },
        'WETLAND'
      )
    )
  }

  return docDefinition;
}